import styled from "styled-components";
import FlexContainer from "../../../styled/content/flex/index";

const Container = styled(FlexContainer)`
    padding: 15px;
    margin: 1% 2%;;
    width: calc((100% / 5) - 4%);
    height: fit-content;
    min-width: 250px;
    background-color: #fff;
    display:flex;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    flex-flow: column;
    cursor: pointer;
    &.inactive{
        background-color: #b3b3b3;
    }
    >div {
        margin-bottom: .5rem;
    }
    div.type{
        padding: .25rem;
        font-size: .65rem;
        border-radius: 4px;
        color: #AB5ECB;
        font-weight: bold;
        border: 1px solid #AB5ECB;  
    }
    >div.title {
        display: flex;
        width: 100%;
        justify-content: space-between;
        margin: 0;
        + div {
            margin-top: .5rem;
            margin-bottom: 0;
        }
        p {
            max-width: 80%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #AB5ECB;
            font-weight: bold;
        }
    }
    > p {
        font-size: .8rem;
        min-height: fit-content;
        max-width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color:#212121;
        margin-top: .25rem;
    }
    a {
        width: 100%;
        height: 100%;
        display:flex;
        flex-flow: column;
        align-items:center;
        justify-content: center;
        text-decoration: none;
        color:inherit;
    }
`

export {Container}